import axios from "axios";
import Config from "src/config";
import { authHeaders } from 'src/actions/authHeaders';

const v2_actionEditarAgenteAi = (agentId, data) => {
    return axios({
        headers: authHeaders(),
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${agentId}/editar`,
        data
        });
};

export default v2_actionEditarAgenteAi;
